<div class="container-fluid toolbar" [class.toolbar-sticky]="isSticky">
  <div class="row align-items-center">
    <div class="col-12 col-md-3 p-0">
      <div class="position-relative toolbar-primary-actions">
        <button type="button" class="btn btn-edit" (click)="openSideBar()">
          <img src="assets/icons/columns.svg" alt="columns" />{{ 'CHANGE_COLUMNS_BTN' | translate }}
        </button>
      </div>
    </div>
    <div class="col-12 col-md-6 p-0">
      <div class="toolbar-scroll">
        <ng-content select="[toolbar-scroll]"></ng-content>
      </div>
    </div>
    <div class="col-12 col-md-3 p-0 toolbar-actions">
      <ng-content select="[toolbar-actions]"></ng-content>
    </div>
  </div>
</div>

<app-list-management-sidebar
  [open]="isChangeColumnsSidebarOpen"
  type="columns"
  [columnDefinition]="columnDefinition"
  [items]="columns"
  [title]="'CHANGE_COLUMNS_BTN'"
  [searchCaption]="'SEARCH_COLUMNS'"
  [validate]="true"
  (onSave)="editClick($event)"
  (onCancel)="sideBarCancel()"
>
</app-list-management-sidebar>
